<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-12 09:48:25
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-28 14:30:47
 -->
<!--  -->
<template >
    <div></div>
</template>

<script>
import { OAUTH2_CONFIG } from '@/page/config/base_config'
import { fetchlocalWebSetting } from '@/framework/util/util'
export default {
  data() {
    return {

    }
  },
  mounted() {
    const router = this.$router
    if (router && router.history && router.history.current && router.history.current.query && router.history.current.query.code) {
      const loading = this.$loading({
        lock: true,
        text: 'el-icon-loading',
        spinner: 'fa fa-spinner fa-5x',
        background: 'rgba(0, 0, 0, 0.3)',
        target: '.sub-main',
        body: true
      })
      this.$http.post('/integrate/uaap/oauth2/login', null, { params: {
        code: router.history.current.query.code,
        redirectUrl: OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + '/oAuth2Login'
      }}).then(response => {
        loading.close()
        /** 放入缓存 */
        this.$store.dispatch('Login', { loginInfo: response.data.loginInfo })
        fetchlocalWebSetting()
        /** 跳转到主页 */
        this.$router.push('/')
        this.$message.success('登录成功!')
      }).catch(error => {
        loading.close()
        this.goToLoginPage(error.msg + ', 通过access_token获取token失败')
      })
    } else {
      this.goToLoginPage()
    }
  },

  methods: {
    goToLoginPage: function(tips) {
      this.$message.error(tips || '登录失败')
      this.$router.push({ path: '/login' })
    }
  }
}

</script>
<style lang='scss' scoped>
</style>
